import React from 'react';
import ReactDOM from 'react-dom';
import HomeContainer from './components/home-container';

ReactDOM.render(<HomeContainer />, document.getElementById('renderReact'));


/** WEBPACK FOOTER **
 ** ./app/home/home.js
 **/